<p-toast class="custom-toast"></p-toast>
<footer class="main-footer bg-primary">
  <div class="pull-right d-none d-sm-inline-block">
      <ul class="nav nav-primary nav-dotted nav-dot-separated justify-content-center justify-content-md-end">
    
    <li class="nav-item">
    <span class="text-small py-2">version {{app_version}}</span>
    </li>
  </ul>
  </div>

  <div *ngIf="isKeyInSessionStorage('userToken')"
     class="support-button-float"
     (click)="showDialog()">
    <img src="../../../../../assets/images/support.png" alt="Support" class="support-icon">
  </div>

  <p-dialog 
  #fileUploadRef 
  header="Support Request" 
  [(visible)]="visible" 
  [modal]="true" 
  [style]="{ width: '42vw', 'max-width': '600px' }" 
  [draggable]="false" 
  [resizable]="false"
  [closable]="true"
>
  <form [formGroup]="supportForm" (ngSubmit)="submitSupportForm()" class="support-form-section needs-validation" novalidate>

    <!-- Query Type -->
    <div class="mb-3">
      <label for="query_type" class="form-label fw-semibold">
        Query Type <span class="text-danger">*</span>
      </label>
      <p-dropdown 
        [options]="complaintList"
        placeholder="Select a query type" 
        id="query_type" 
        formControlName="query_type"
        optionLabel="field_value" 
        optionValue="field_code"
        [showClear]="true"
        class="w-100"
      ></p-dropdown>
      <div class="invalid-feedback d-block" *ngIf="supportForm.get('query_type').hasError('required') && submitted">
        Please select a query type.
      </div>
    </div>

    <!-- Query Input -->
    <div class="mb-3">
      <label for="query" class="form-label fw-semibold">
        Your Message <span class="text-danger">*</span>
      </label>
      <textarea 
        id="query" 
        pInputTextarea 
        rows="4"
        formControlName="query" 
        placeholder="Describe your issue or question..."
        class="form-control"
      ></textarea>
      <div class="invalid-feedback d-block" *ngIf="supportForm.get('query').hasError('required') && submitted">
        Please enter your message.
      </div>
    </div>

    <!-- Scrollable File Upload -->
    <div class="mb-3 p-3 border rounded bg-light">
      <label class="form-label fw-semibold mb-1">
        Attach Screenshot / Image <small class="text-muted">(optional)</small>
      </label>
      <div class="text-muted small mb-2">
        Accepted formats: PNG, JPG, JPEG — Max size: 1MB
      </div>

      <!-- Scrollable area for file upload list -->
      <div style="max-height: 180px; overflow-y: auto;">
        <p-fileUpload 
          #fileUpload 
          name="myfile[]" 
          (onSelect)="onSelectFile($event)" 
          [auto]="true" 
          [multiple]="true" 
          accept="image/*" 
          [maxFileSize]="1000000"
          chooseLabel="Browse"
          uploadLabel="Upload"
          cancelLabel="Remove"
        ></p-fileUpload>
      </div>
    </div>

    <!-- Footer -->
    <div class="d-flex justify-content-end gap-2 border-top pt-3">
      <button 
        class="btn btn-primary px-4" 
        type="submit"
      >
        <i class="bi bi-send me-1"></i> Submit
      </button>
      <button 
        class="btn btn-outline-secondary px-4" 
        type="button" 
        (click)="clearImageUpload()"
      >
        <i class="bi bi-x-circle me-1"></i> Cancel
      </button>
    </div>

  </form>
</p-dialog>
  
  © <script>document.write(new Date().getFullYear())</script>{{ currentYear }} <a href="https://www.emoneeds.com/">emoneeds</a>. All Rights Reserved.
</footer>